/**
 * Column template shared by the documents table header, rows, folders, and skeleton.
 * It is a CSS variable so the phone can drop the Type / Size / Status / Received / Uploaded /
 * Processed tracks (the rows show them on a second line under the name instead).
 *
 * Put `DOCUMENT_GRID_COLS_CLASS` on an ancestor of the table and pass
 * `DOCUMENT_GRID_COLS` to `<GridTable columns>`.
 */
export const DOCUMENT_GRID_COLS = 'var(--document-grid-cols)'
export const DOCUMENT_GRID_COLS_CLASS =
  '[--document-grid-cols:28px_minmax(0,1fr)_32px] md:[--document-grid-cols:28px_minmax(0,1fr)_60px_70px_90px_104px_136px_136px_28px]'

/**
 * Phone-only tap target for a row's checkbox cell: the cell reaches the row's left
 * edge and its full height (the row is `px-4 py-2.5`), so a tap near the 16 px box
 * selects the row instead of opening it. The checkbox itself does not move.
 */
export const ROW_CHECKBOX_HIT_AREA =
  'max-md:-my-2.5 max-md:-ml-4 max-md:flex max-md:items-center max-md:self-stretch max-md:py-2.5 max-md:pl-4'
/** Same for the select-all cell of the header (`px-4 py-2`). */
export const HEADER_CHECKBOX_HIT_AREA =
  'max-md:-my-2 max-md:-ml-4 max-md:flex max-md:items-center max-md:self-stretch max-md:py-2 max-md:pl-4'
